<template>
    <div :class="wrapperClass">
        <label v-if="label" class="hh-label">{{label}}:</label>
        <input type="text" :class="inputClass" class="form-control hh-blue text-bold hh-amount-container"
               v-model="displayValue"
               @blur="blurEvent"
               @focus="isInputActive = true"
               placeholder="$"
               autocomplete="off"
               :required="required"
        />
    </div>
</template>

<script>
  export default {
    name: 'CurrencyInput',

    props: {
        value: Number,
        required: Boolean,
        label: String,
        wrapperClass: {
          type: String,
          default: ''
        },
        inputClass: {
          type: String,
          default: ''
        },
        displayDollarSign: {
          type: Boolean,
          default: true
        }
    },

    data: () => {
      return {
        isInputActive: false
      }
    },

    methods: {
      blurEvent() {
        this.isInputActive = false
        this.$emit('blurred', true)
      },
    },

    computed: {
      displayValue: {
        get: function() {
          if (this.value == null) {
              return `${this.dollarSign}0`
          }
          if (this.isInputActive) {
            return this.value == 0 || this.value == null ? '' : this.value.toString()
          } else {
            return `${this.dollarSign} ${this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}`
          }
        },
        set: function(modifiedValue) {
          let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
          if (isNaN(newValue)) {
            newValue = 0
          }
          this.$emit('input', newValue)
        }
      },
      dollarSign() {
        return this.displayDollarSign ? '$' : ''
      }
    },

    watch: {
      isInputActive(to) {
        if (to) {
          this.$emit('input', 0)
        }
      }
    }


  }
</script>

<style scoped>

</style>